import { Button } from "@/components/ui/button";

// Solid blue call-to-action used for every "Book Now" (no bubbles / water effects)
const SoapyButton = ({ children, className = "", size = "default", ...props }) => (
  <div className="relative block w-full sm:w-auto sm:inline-block">
    <Button size={size} {...props}
      className={`${className} bg-sky-500 hover:bg-sky-400 text-white border-0 shadow-[0_8px_30px_-8px_rgba(14,165,233,0.6)] hover:-translate-y-0.5 transition-[background-color,transform] duration-200`}>
      {children}
    </Button>
  </div>
);

export default SoapyButton;
